import * as products from 'app/mocks/data/catalogue/products/list'
import * as managers from 'app/mocks/data/park/managers/list'

import { StatusReport } from 'app/types/reports'
import type { InitialVatReport } from 'app/types/reports/vat'
import { TypeProductVatReport } from 'app/types/reports/vat'
import { PaymentMethodSale } from 'app/types/transactions/sale'

export const vatReport1: InitialVatReport = {
    id: 1,
    creation_date: '2025-01-01T00:00:00',
    status: StatusReport.enum.DONE,
    date_start: '2024-01-01',
    date_end: '2024-04-31',
    months: [
        {
            date: '2024-01-01',
            vats: [
                {
                    vat: 20,
                    products: [
                        {
                            ...products.product1,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 1,
                                date: '2024-01-01T12:00:00',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 5,
                            amount_vat: (5 * 20) / 100,
                            amount_with_vat: 5 * (1 + 20 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 2,
                                date: '2024-01-12',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 20) / 100,
                            amount_with_vat: 10 * (1 + 20 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 2,
                                date: '2024-01-12',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 20) / 100,
                            amount_with_vat: 10 * (1 + 20 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 3,
                                date: '2024-01-14',
                            },
                            payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
                            amount_without_vat: 3,
                            amount_vat: (3 * 20) / 100,
                            amount_with_vat: 3 * (1 + 20 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 3,
                                date: '2024-01-14',
                            },
                            payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
                            amount_without_vat: 3,
                            amount_vat: (3 * 20) / 100,
                            amount_with_vat: 3 * (1 + 20 / 100),
                        },
                    ],
                },
                {
                    vat: 10,
                    products: [
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 1,
                                date: '2024-01-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 5,
                            amount_vat: (5 * 10) / 100,
                            amount_with_vat: 5 * (1 + 10 / 100),
                        },
                        {
                            ...products.product4,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 1,
                                date: '2024-01-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 10) / 100,
                            amount_with_vat: 10 * (1 + 10 / 100),
                        },
                        {
                            ...products.product5,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 3,
                                date: '2024-01-14',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 10) / 100,
                            amount_with_vat: 10 * (1 + 10 / 100),
                        },
                    ],
                },
            ],
        },
        {
            date: '2024-02-01',
            vats: [
                {
                    vat: 10,
                    products: [
                        {
                            ...products.product1,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 1,
                                date: '2024-02-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 5,
                            amount_vat: (5 * 10) / 100,
                            amount_with_vat: 5 * (1 + 10 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 2,
                                date: '2024-02-12',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 10) / 100,
                            amount_with_vat: 10 * (1 + 10 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 2,
                                date: '2024-02-12',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 10) / 100,
                            amount_with_vat: 10 * (1 + 10 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.REFUND,
                            vat: 10,
                            sale: {
                                id: 3,
                                date: '2024-02-14',
                            },
                            payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
                            amount_without_vat: 3,
                            amount_vat: (3 * 10) / 100,
                            amount_with_vat: 3 * (1 + 10 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.REFUND,
                            vat: 10,
                            sale: {
                                id: 4,
                                date: '2024-02-15',
                            },
                            payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
                            amount_without_vat: 3,
                            amount_vat: (3 * 20) / 100,
                            amount_with_vat: 3 * (1 + 20 / 100),
                        },
                    ],
                },
            ],
        },
        {
            date: '2024-03-01',
            vats: [
                {
                    vat: 20,
                    products: [
                        {
                            ...products.product1,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 1,
                                date: '2024-03-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 5,
                            amount_vat: (5 * 20) / 100,
                            amount_with_vat: 5 * (1 + 20 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 1,
                                date: '2024-03-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 20) / 100,
                            amount_with_vat: 10 * (1 + 20 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 2,
                                date: '2024-03-02',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 20) / 100,
                            amount_with_vat: 10 * (1 + 20 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 3,
                                date: '2024-03-03',
                            },
                            payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
                            amount_without_vat: 3,
                            amount_vat: (3 * 20) / 100,
                            amount_with_vat: 3 * (1 + 20 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 4,
                                date: '2024-03-04',
                            },
                            payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
                            amount_without_vat: 3,
                            amount_vat: (3 * 20) / 100,
                            amount_with_vat: 3 * (1 + 20 / 100),
                        },
                    ],
                },
                {
                    vat: 10,
                    products: [
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 1,
                                date: '2024-03-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 5,
                            amount_vat: (5 * 10) / 100,
                            amount_with_vat: 5 * (1 + 10 / 100),
                        },
                        {
                            ...products.product4,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 1,
                                date: '2024-03-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 10) / 100,
                            amount_with_vat: 10 * (1 + 10 / 100),
                        },
                        {
                            ...products.product5,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 2,
                                date: '2024-03-02',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 10) / 100,
                            amount_with_vat: 10 * (1 + 10 / 100),
                        },
                    ],
                },
            ],
        },
        {
            date: '2024-04-01',
            vats: [
                {
                    vat: 5,
                    products: [
                        {
                            ...products.product1,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 5,
                            sale: {
                                id: 1,
                                date: '2024-04-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 5,
                            amount_vat: (5 * 5) / 100,
                            amount_with_vat: 5 * (1 + 5 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 5,
                            sale: {
                                id: 1,
                                date: '2024-04-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 5) / 100,
                            amount_with_vat: 10 * (1 + 5 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 5,
                            sale: {
                                id: 1,
                                date: '2024-04-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 5) / 100,
                            amount_with_vat: 10 * (1 + 5 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 5,
                            sale: {
                                id: 2,
                                date: '2024-04-02',
                            },
                            payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
                            amount_without_vat: 3,
                            amount_vat: (3 * 5) / 100,
                            amount_with_vat: 3 * (1 + 20 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 3,
                                date: '2024-04-03',
                            },
                            payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
                            amount_without_vat: 3,
                            amount_vat: (3 * 5) / 100,
                            amount_with_vat: 3 * (1 + 5 / 100),
                        },
                    ],
                },
                {
                    vat: 10,
                    products: [
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 1,
                                date: '2024-04-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 5,
                            amount_vat: (5 * 10) / 100,
                            amount_with_vat: 5 * (1 + 10 / 100),
                        },
                        {
                            ...products.product4,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 1,
                                date: '2024-04-01',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 10) / 100,
                            amount_with_vat: 10 * (1 + 10 / 100),
                        },
                        {
                            ...products.product5,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 4,
                                date: '2024-04-04',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 10,
                            amount_vat: (10 * 10) / 100,
                            amount_with_vat: 10 * (1 + 10 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 10,
                            sale: {
                                id: 5,
                                date: '2024-04-05',
                            },
                            payment_method: PaymentMethodSale.enum.CREDIT_CARD,
                            amount_without_vat: 3,
                            amount_vat: (3 * 10) / 100,
                            amount_with_vat: 3 * (1 + 10 / 100),
                        },
                    ],
                },
                {
                    vat: 20,
                    products: [
                        {
                            ...products.product1,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 4,
                                date: '2024-04-04',
                            },
                            payment_method: PaymentMethodSale.enum.KONVIVES,
                            amount_without_vat: 5,
                            amount_vat: (5 * 20) / 100,
                            amount_with_vat: 5 * (1 + 20 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 4,
                                date: '2024-04-04',
                            },
                            payment_method: PaymentMethodSale.enum.KONVIVES,
                            amount_without_vat: 10,
                            amount_vat: (10 * 20) / 100,
                            amount_with_vat: 10 * (1 + 20 / 100),
                        },
                        {
                            ...products.product2,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 5,
                                date: '2024-04-05',
                            },
                            payment_method: PaymentMethodSale.enum.KONVIVES,
                            amount_without_vat: 10,
                            amount_vat: (10 * 20) / 100,
                            amount_with_vat: 10 * (1 + 20 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 5,
                                date: '2024-04-05',
                            },
                            payment_method: PaymentMethodSale.enum.KONVIVES,
                            amount_without_vat: 3,
                            amount_vat: (3 * 20) / 100,
                            amount_with_vat: 3 * (1 + 20 / 100),
                        },
                        {
                            ...products.product3,
                            type: TypeProductVatReport.enum.SALE,
                            vat: 20,
                            sale: {
                                id: 6,
                                date: '2024-04-06',
                            },
                            payment_method: PaymentMethodSale.enum.KONVIVES,
                            amount_without_vat: 3,
                            amount_vat: (3 * 20) / 100,
                            amount_with_vat: 3 * (1 + 20 / 100),
                        },
                    ],
                },
            ],
        },
    ],
    manager: managers.manager1,
}

export const vatReport2: InitialVatReport = {
    id: 2,
    creation_date: '2025-04-01T00:00:00',
    status: StatusReport.enum.IN_PROGRESS,
    date_start: '2025-03-01',
    date_end: '2025-03-31',
    manager: managers.manager2,
}

export const vatReport3: InitialVatReport = {
    id: 3,
    creation_date: '2025-04-14T00:00:00',
    status: StatusReport.enum.IN_PROGRESS,
    date_start: '2025-01-01',
    date_end: '2025-03-31',
    manager: managers.manager3,
}
